import ErrorActions from './controls/error-actions';
import NormalActions from './controls/normal-actions';
import React from 'react';
import { observer } from 'mobx-react';

// Most likely does not need its own component now
// but was reduced as things were abstracted

@observer
class Actions extends React.Component {
  render() {
    return (
      <div className="nowrap actions action-base flex-none flex-row">
        <NormalActions onEdit={this.props.onEdit} />
        <ErrorActions />
      </div>
    );
  }
}

Actions.defaultProps = {
  onEdit: () => {}
};

export default Actions;
